import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class Boyle extends Lit3formBlock {
  static get characterName() {
    return 'boyle';
  }

  static get characterProperties() {
    return {
      cta: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid boyle-layout">
          ${this.headerHTML} ${this.descriptionHTML} ${this.ctasHTML}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get headerHTML() {
    return this.headerText
      ? html`
          <div class="header details-row">
            <h2>${unsafeHTML(this.headerText)}</h2>
          </div>
        `
      : ``;
  }

  get descriptionHTML() {
    return this.descriptionText
      ? html`
          <p class="description">
            ${unsafeHTML(this.descriptionText)}
          </p>
        `
      : ``;
  }

  get ctasHTML() {
    return this.ctasList.length
      ? html`
          <div class="ctas-list">
            ${this.ctasList.map(cta => {
              const ctaType =
                cta.type === 'Primary button' ? 'primary' : 'download';
              cta.fullWidth = true;
              return html`
                <cta-button
                  cta-data=${JSON.stringify(cta)}
                  cta-type=${ctaType}
                  .ctaAnalyticsData=${analyticsCtaDataObject(
                    cta,
                    this.headerText
                  )}
                ></cta-button>
              `;
            })}
          </div>
        `
      : html``;
  }

  get ctasList() {
    return this.content.call_to_actions || [];
  }
}
Boyle.defineElement();
